<template>
    <div class="container">
        <v-card>
            <v-card-text>
                <v-row>
                    <v-col cols="11">
                        <v-card-title class="titulopagina">LISTADO  DE  DESPACHOS  DE  HARINA</v-card-title>
                    </v-col>
                    <v-col cols="1">
                        <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas">
                            <v-icon color="blue" large>help</v-icon>
                        </v-alert>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <modal-ayuda></modal-ayuda>
        <v-card class="mt-2">
            <tabla-paginada @cargar="cargar($event)" @detalle="detalle" @recepcion="recepcion"></tabla-paginada>
        </v-card>
    </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import TablaPaginadaVue from '../../components/shared/TablaPaginada.vue';
import ModalAyudas from '../../components/shared/ModalAyudas.vue';
export default {
    data:()=>({
        lista:[],
        links:[],
        columnas:[
            {nombre:'Fecha',key:'fecha',path:'fecha',tipo:'date',busqueda:'',searchable:true},
          //  {nombre:'Tipo Despacho',tipo:'select',path:'tipo_produccion',key:'tipo_produccion_id',searchable:true,busqueda:'1',opciones:[{id:1, tipo:'Harina'}],valor_opcion:'id',texto_opcion:'tipo'},

            {nombre:'Destino',key:'nombre_bodega',path:'nombre_bodega',tipo:'texto',busqueda:'',searchable:true},
            {nombre:'Patente',key:'patente',path:'patente',tipo:'texto',busqueda:'',searchable:true},
            {nombre:'Guía',key:'guia',path:'guia',tipo:'texto',busqueda:'',searchable:true},
            {nombre:'Folio PCC4',key:'folio_pcc4',path:'folio_pcc4',tipo:'texto',busqueda:'',searchable:true},
            {nombre:'Total Maxisacos',key:'cantidad_maxisacos',path:'cantidad_maxisacos',tipo:'numero',busqueda:'',searchable:false},
            {nombre:'Peso Total Maxisacos',key:'peso_maxisacos',path:'peso_maxisacos',tipo:'numero',busqueda:'',searchable:false},
            {nombre:'Detalle', key:'detalle',tipo:'evento',color:'#1565C0',icono:'zoom_in',evento:'detalle',searchable:false},
            {nombre:'Recepcionar', key:'recepcion',tipo:'evento', icono_ok:'Recepcionado',color:'#00796B',icono:'assignment',evento:'recepcion',searchable:false,disabled:'btn_recepcion'},
        ],
    }),
    mounted(){
        this.cargar('?limit=10');
    },
    methods:{
        abrirAyudas(){
            const jiji = [
                {   titulo:`Ayuda de Listado de Despachos de Harina`,    tipo:`titulo`},
                {   tipo:`label`,   texto:`En esta pantalla se muestra un listado de despachos de harina, el detalle de cada uno y si está recepcionado`},
                {   tipo:`label`,   texto:`- Se pueden filtrar los despachos por fecha, destino, patente, guía y folio PCC4 en la primera fila de la tabla después de las cabeceras.`},
                {   tipo:`label`,   texto:`- Para ver los detalles de un despacho, se debe pulsar el botón con icono de la lupa (columna "Detalle" insert_img_help-despachos-harina_ic1.png ) , en donde se mostrará una nueva ventana que tiene todos los detalles del despacho incluida la opción para modificarlos`},
                {   tipo:`label`,   texto:`- Una vez el despacho esté asociado con su respectivo despacho de romana, se podrá marcar como recepcionado en bodegas de Talcahuano pulsando el botón con el icono de la hoja (columna "Recepcionar" insert_img_help-despachos-harina_ic2.png ), en donde se mostrará una nueva ventana con los detalles de la recepción del despacho y poder registrarla correctamente digitando el folio de abastecimiento, la fecha de recepción, observaciones (si aplica) y finalizando con el botón "Guardar" ( insert_img_help-asignar-despacho-bodega_ic3.png )`},
            ];
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargar(query){
            this.mostrarLoading({titulo:'Cargando Despachos ... ',color:'green'})
            await this.axios.get(`${this.base_url}despacho_harina${query}`,this.headers).then((res)=>{
                console.log('res',res.data.data);
                this.lista = res.data.data.data;
                //this.$emit('setear_tabla',{columnas:this.columnas,lista:this.lista});
                this.actualizarTablaPaginada({columnas:this.columnas,lista:this.lista,total_paginas:res.data.data.last_page})
            }).catch((e)=>{
                this.errorMessage(e, "Error al traer Despachos ");
            })
            this.ocultarLoading();
            
        },

        detalle($event){
            console.log($event);
            this.$router.push({name:'despachos_harina_detalle',params:{id:$event.item.id}});
        },

        recepcion($event){
            console.log($event);
            this.$router.push({name:'despacho_recepcion',params:{id:$event.item.id}});
        },
        ...mapMutations(['actualizarTablaPaginada','mostrarLoading','ocultarLoading'])
    },
    computed:{
        ...mapState(['base_url','headers'])
    },
    components:{
        'tabla-paginada':TablaPaginadaVue,
        'modal-ayuda': ModalAyudas,
    }
}
</script>